import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import $ from 'jquery';
import md5 from 'md5';
var jsonp = require('jsonp');
import { threadList, banner, follow, unFollow, thumbs, collect, userCheck, userInfo } from '@/api/mg';
var threadListParams = {
  perPage: 10,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 3,
  sequence: 0,
  'filter[categoryids][0]': 1,
  'filter[sticky]': 2
};
import { logEvent } from 'firebase/analytics';
export default {
  data: function data() {
    return {
      topData: [],
      userId: '',
      totalPage: 0,
      clubData: [],
      typeArr: [{
        txt: 'Latest',
        selected: true
      }, {
        txt: 'Hot',
        selected: false
      }, {
        txt: 'Following',
        selected: false
      }],
      type: 'Latest',
      isShowSelectPop: false,
      isShowWrap: false,
      loading: false,
      finished: false,
      isLoading: false,
      banner: [
        // { src: require('../../../assets/images/Banner1.png') },
        // { src: require('../../../assets/images/Banner2.png') }
      ],
      infos: [{
        isFollow: true
      }, {
        isFollow: false
      }, {
        isFollow: true
      }, {
        isFollow: false
      }],
      playerOptions: {
        height: '360',
        autoplay: true,
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: 'http://vjs.zencdn.net/v/oceans.mp4'
        }],
        poster: './defaultPage.png'
      }
    };
  },
  created: function created() {
    this.getThreadList({
      perPage: 10,
      page: 1,
      'filter[categoryids][0]': 1,
      'filter[sticky]': 1
    });
    this.userId = localStorage.getItem('userId');
    threadListParams.page = 1;
    threadListParams['filter[sort]'] = 1;
    this.getThreadList(threadListParams);
    this.getBanner({
      page: 1,
      perPage: 6
    });
  },
  mounted: function mounted() {
    console.log('首屏加载时间为' + (new Date().getTime() - performance.timing.navigationStart) + 'ms');
    var that = this;
    this.$nextTick(function () {
      $('.wrap').on('click', function () {
        that.isShowSelectPop = false;
        that.isShowWrap = false;
      });
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        console.log('12345');
        if (window.Android) {
          var devicePixelRatio = window.devicePixelRatio;
          console.log(devicePixelRatio);
          console.log(window.Android.getStatusBarHeight());
          var pxSize = Number(window.Android.getStatusBarHeight() / devicePixelRatio);
          console.log('pxsize', pxSize);
          $('.container').css('padding-top', pxSize);
        }
      }
    });
  },
  methods: {
    getOrigin: function getOrigin(item) {
      item.isTranslate = false;
    },
    translate: function translate(item) {
      var _this = this;
      if (item.content.dst) {
        item.isTranslate = true;
        return;
      }
      var appid = '20211116001000645'; // 百度翻译API的appid
      var key = 'RExx85Y9o4DqUHOrcaqV'; // 百度翻译API的key
      var salt = new Date().getTime();
      var query = item.content.text;
      var from = 'th';
      var to = 'en';
      var str1 = appid + query + salt + key;
      var sign = md5(str1);
      var url = "http://api.fanyi.baidu.com/api/trans/vip/translate?q=".concat(query, "&appid=").concat(appid, "&salt=").concat(salt, "&from=").concat(from, "&to=").concat(to, "&sign=").concat(sign);
      jsonp(url, null, function (err, data) {
        if (err) {
          _this.$toast(err.error_msg);
        } else {
          item.isTranslate = true;
          item.content.dst = data.trans_result[0].dst;
        }
      });
    },
    toCollect: function toCollect(item) {
      var _this2 = this;
      var params = {
        id: item.threadId,
        isFavorite: !item.isFavorite
      };
      collect(params).then(function (res) {
        if (res.Code === 0) {
          if (item.isFavorite) {
            item.likeReward.favoriteCount -= 1;
          } else {
            item.likeReward.favoriteCount += 1;
          }
          item.isFavorite = !item.isFavorite;
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    thumbsUp: function thumbsUp(item) {
      var _this3 = this;
      var params = {
        data: {
          attributes: {
            isLiked: !item.isLike
          }
        },
        pid: item.postId,
        id: item.threadId
      };
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      console.log(params);
      thumbs(params).then(function (res) {
        if (res.Code === 0) {
          if (item.isLike) {
            item.likeReward.likePayCount -= 1;
          } else {
            item.likeReward.likePayCount += 1;
          }
          item.isLike = !item.isLike;
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    toMe: function toMe(pid, status) {
      // this.$router.push({ path: '/others', query: { pid, status } })
    },
    toFollow: function toFollow(userId, item, str) {
      var _this4 = this;
      var params = {
        toUserId: userId
      };
      follow(params).then(function (res) {
        if (res.Code === 0) {
          _this4.topData.forEach(function (itm) {
            if (itm.user.userId === item.user.userId) {
              itm.user.follow_status = '0';
            }
          });
          _this4.clubData.forEach(function (itm) {
            if (itm.user.userId === item.user.userId) {
              itm.user.follow_status = '0';
            }
          });
          // if (str) {
          //   console.log(item.user.userId, 'follow')
          //   this.topData.forEach((itm) => {
          //     if (itm.user.userId === item.user.userId) {
          //       itm.user.follow_status = '0'
          //     }
          //   })
          //   console.log(this.topData, 'this.topData')
          // } else {
          //   this.clubData.forEach((itm) => {
          //     console.log(itm.user.userId)
          //     if (itm.user.userId === item.user.userId) {
          //       itm.user.follow_status = '0'
          //     }
          //   })
          // }
        } else {
          _this4.$toast(res.Message);
        }
      });
    },
    toUnfollow: function toUnfollow(userId, item, str) {
      var _this5 = this;
      var params = {
        type: 1,
        id: userId
      };
      console.log(unFollow, 'params');
      unFollow(params).then(function (res) {
        if (res.Code === 0) {
          // if (str) {
          //   console.log(item.user.userId, 'toUnfollow')
          //   this.topData.forEach((itm) => {
          //     if (itm.user.userId === item.user.userId) {
          //       itm.user.follow_status = '2'
          //     }
          //   })
          //   console.log(this.topData, 'this.topData')
          // } else {
          //   this.clubData.forEach((itm) => {
          //     if (itm.user.userId === item.user.userId) {
          //       itm.user.follow_status = '2'
          //     }
          //   })
          // }
          _this5.topData.forEach(function (itm) {
            if (itm.user.userId === item.user.userId) {
              itm.user.follow_status = '2';
            }
          });
          _this5.clubData.forEach(function (itm) {
            if (itm.user.userId === item.user.userId) {
              itm.user.follow_status = '2';
            }
          });
        } else {
          _this5.$toast(res.Message);
        }
      });
    },
    toUrl: function toUrl(url) {
      // 未登录
      var token = JSON.parse(localStorage.getItem('appParams')).token;
      var u = navigator.userAgent;
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        if (window.Android) {
          if (token == '') {
            window.Android.unLogin();
          } else {
            window.Android.gotoWebView(url);
          }
        }
      } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
        if (token == '') {
          this.$bridge.callhandler('unLogin', null, function (response) {});
        } else {
          this.$bridge.callhandler('gotoWebView', url, function (res) {});
        }
      }
    },
    getBanner: function getBanner(params) {
      var _this6 = this;
      banner(params).then(function (res) {
        if (res.Code === 0) {
          _this6.banner = res.Data.pageData;
        } else {
          _this6.$toast(res.Message);
        }
      });
    },
    filter: function filter(html) {
      return html.replace(/<(?:.|\n)*?>/gm, '').replace(/(&rdquo;)/g, '"').replace(/&ldquo;/g, '"').replace(/&mdash;/g, '-').replace(/&nbsp;/g, '').replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/<[\w\s"':=\/]*/, '');
    },
    getThreadList: function getThreadList(params) {
      var _this7 = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          if (params['filter[sticky]'] === 1) {
            _this7.topData = res.Data.pageData;
            _this7.topData.forEach(function (item) {
              item.user.follow_status = item.user.follow_status;
              // 添加置顶视频封面
              if (item.content.indexes['101'] && item.content.indexes['101'].body.length > 0 && item.content.indexes['101'].body[0].type == 2) {
                item.content.indexes['101'].body[0].poster = './defaultPage.png';
              }
              item.content.text = _this7.filter(item.content.text);
            });
            return;
          }
          _this7.totalPage = res.Data.totalPage;
          res.Data.pageData.forEach(function (item) {
            item.isTranslate = false;
            item.user.follow_status = item.user.follow_status;
          });
          _this7.clubData = [].concat(_toConsumableArray(_this7.clubData), _toConsumableArray(res.Data.pageData));
          _this7.clubData.forEach(function (item) {
            // 添加视频封面
            if (item.content.indexes['101'] && item.content.indexes['101'].body.length > 0 && item.content.indexes['101'].body[0].type == 2) {
              item.content.indexes['101'].body[0].poster = './defaultPage.png';
            }
            item.content.text = _this7.filter(item.content.text);
          });
          _this7.loading = false;
          _this7.isLoading = false;
        } else {
          _this7.$toast(res.Message);
        }
      });
    },
    toSelect: function toSelect(item) {
      if (item.selected) {
        return;
      }
      this.typeArr.forEach(function (itm) {
        itm.selected = false;
      });
      item.selected = true;
      this.isShowWrap = false;
      this.isShowSelectPop = false;
      this.type = item.txt;
      this.clubData = [];
      var obj = {
        'Hot': 3,
        'Latest': 1,
        'Following': 1
      };
      threadListParams['filter[sort]'] = obj[item.txt];
      item.txt === 'Following' ? threadListParams['filter[attention]'] = 1 : threadListParams['filter[attention]'] = 0;
      item.txt === 'Hot' || item.txt === 'Following' ? delete threadListParams['filter[sticky]'] : threadListParams['filter[sticky]'] = 2;
      threadListParams.page = 1;
      this.finished = false;
      this.getThreadList(threadListParams);
    },
    showSelectPop: function showSelectPop() {
      this.isShowWrap = true;
      this.isShowSelectPop = true;
    },
    onLoad: function onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      threadListParams.page++;
      if (threadListParams.page <= this.totalPage) {
        this.getThreadList(threadListParams);
      } else {
        this.finished = true;
      }
      // setTimeout(() => {
      //   for (let i = 0; i < 10; i++) {
      //     this.infos.push(this.infos.length + 1)
      //   }

      //   // 加载状态结束
      //   this.loading = false

      //   // 数据全部加载完成
      //   if (this.infos.length >= 20) {
      //     this.finished = true
      //   }
      // }, 1000)
    },
    answerQuestion: function answerQuestion() {
      // eslint-disable-next-line no-undef
      logEvent(this.$analytics, 'Club_Survey_Click', {
        Club_Survey_Click_Times: ''
      });
      var token = JSON.parse(localStorage.getItem('appParams')).token;
      // 判断未登录
      if (token == '') {
        var u = navigator.userAgent;
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          window.Android.unLogin();
        } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
          this.$bridge.callhandler('unLogin', null, function (response) {});
        }
        return;
      } else {
        this.$router.push({
          path: '/social/questionList'
        });
      }
    },
    toManual: function toManual() {
      // eslint-disable-next-line no-undef
      logEvent(this.$analytics, 'Club_Brochure_Click', {
        Club_Brochure_Click_Times: ''
      });
      var token = JSON.parse(localStorage.getItem('appParams')).token;
      if (token == '') {
        var u = navigator.userAgent;
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          window.Android.unLogin();
        } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
          this.$bridge.callhandler('unLogin', null, function (response) {});
        }
        return;
      } else {
        this.$router.push({
          path: '/social/manual'
        });
      }
    },
    toTestDrive: function toTestDrive() {
      var uid = JSON.parse(localStorage.getItem('appParams')).uid;
      var token = JSON.parse(localStorage.getItem('appParams')).token;
      var lan = JSON.parse(localStorage.getItem('appParams')).language.replace(/\"/g, '');
      var u = navigator.userAgent;

      // eslint-disable-next-line no-undef
      logEvent(this.$analytics, 'Club_TestDrive_Click', {
        Club_TestDrive_Click_Times: ''
      });

      // 判断未登录
      if (token == '') {
        // var u = navigator.userAgent
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          window.Android.unLogin();
        } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
          this.$bridge.callhandler('unLogin', null, function (response) {});
        }
        return;
      }
      if (process.env.NODE_ENV === 'production') {
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          window.Android.gotoWebView("https://iov-tap.mgthai.com/360/vehicle/#/information?token=" + token + "&uid=" + uid + "&language=" + lan + "&isBack=false");
        } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
          this.$bridge.callhandler('gotoWebView', "https://iov-tap.mgthai.com/360/vehicle/#/information?token=" + token + "&uid=" + uid + "&language=" + lan + "&isBack=false", function (res) {});
        }
      } else {
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          window.Android.gotoWebView("https://tpage.soimt.com/APP/Thailand/360presale/index.html#/information?token=" + token + "&uid=" + uid + "&language=" + lan + "&isBack=false");
        } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
          this.$bridge.callhandler('gotoWebView', "https://tpage.soimt.com/APP/Thailand/360presale/index.html#/information?token=" + token + "&uid=" + uid + "&language=" + lan + "&isBack=false", function (res) {});
        }
      }
    },
    toTopic: function toTopic(topicId) {
      var token = JSON.parse(localStorage.getItem('appParams')).token;
      // 判断未登录
      if (token == '') {
        var u = navigator.userAgent;
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          window.Android.unLogin();
        } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
          this.$bridge.callhandler('unLogin', null, function (response) {});
        }
      } else {
        this.$router.push({
          path: '/social/topic',
          query: {
            topicId: topicId,
            from: 'club'
          }
        });
      }
    },
    onRefresh: function onRefresh() {
      var params = JSON.parse(localStorage.getItem('appParams'));
      this.finished = false;
      this.clubData = [];
      this.topData = [];
      this.getThreadList({
        perPage: 10,
        page: 1,
        'filter[categoryids][0]': 1,
        'filter[sticky]': 1
      });
      threadListParams.page = 1;
      this.getThreadList(threadListParams);
      this.getBanner({
        page: 1,
        perPage: 6
      });
      // const checkParams = { appUserId: params.uid, nickname: params.nickname }
      // userCheck(checkParams).then((res) => {
      //   if (res.Code === 0) {
      //     localStorage.setItem('socialToken', res.Data.accessToken)
      //     this.$store.state.socialToken = res.Data.accessToken
      //     this.getUserInfo({ pid: res.Data.uid })
      //   }
      // })
    },
    getUserInfo: function getUserInfo(params) {
      var _this8 = this;
      userInfo(params).then(function (res) {
        if (res.Code === 0) {
          localStorage.setItem('userId', res.Data.id);
          localStorage.setItem('pid', res.Data.group.pid);
          localStorage.setItem('nickname', res.Data.nickname);
          _this8.$store.state.nickname = res.Data.nickname;
        } else {
          _this8.$toast(res.Message);
        }
      });
    },
    toDetail: function toDetail(threadId, postCount) {
      var token = JSON.parse(localStorage.getItem('appParams')).token;
      // 判断未登录
      if (token == '') {
        var u = navigator.userAgent;
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          window.Android.unLogin();
        } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
          this.$bridge.callhandler('unLogin', null, function (response) {});
        }
      } else {
        this.$router.push({
          path: '/social/detail',
          query: {
            from: 'club',
            threadId: threadId,
            postCount: postCount
          }
        });
      }
    }
  }
};